<script>
import AdminLayout from '@layouts/admin-main'
import FeesetInfo from '@components/admin/pg-feeset-info'
import { fetchFeesets, deleteFeeset, setDefaultFeeset } from '@apis/admin/pg'
import { mapState } from 'vuex'
import fromPairs from 'lodash/fromPairs'

export default {
  page: {
    title: 'Admin::PgFeeset',
    meta: [{ name: 'description', content: 'Admin::PgFeeset' }],
  },
  components: {
    AdminLayout,
    FeesetInfo,
  },
  data() {
    return {
      feesets: [],
      loading_feeset_default_change: false,
      target_feeset_seq: 0,
      show_feeset_info: false,
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      Promise.all([this.loadFeesets()]).catch((e) =>
        this.$toasted.error(e.message)
      )
    },
    async loadFeesets() {
      const { data } = await fetchFeesets()

      this.feesets = data
    },
    handleCreateFeeset() {
      this.show_feeset_info = true
      this.target_feeset_seq = null
    },
    handleUpdateFeeset({ seq }) {
      this.show_feeset_info = true
      this.target_feeset_seq = seq
    },
    handleFeesetSubmit(seq) {
      this.init()
      this.target_feeset_seq = seq
    },
    handleChangeDefault(e, title) {
      this.loading_feeset_default_change = true
      setDefaultFeeset(e.target.value)
        .then(() => this.loadFeesets())
        .then(() =>
          this.$toasted.success(title, this.$t('pg_feeset.msg_fee_bundle'))
        )
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading_feeset_default_change = false
        })
    },
    async handleDeleteFeeset(seq) {
      try {
        if (
          !(await this.$confirm(
            this.$t('admin.confirm_delete'),
            this.$t('admin.modal_confirm'),
            {
              type: 'warning',
            }
          ).catch(() => false))
        )
          return

        await deleteFeeset(seq)
        await this.loadFeesets()
      } catch (e) {
        this.$toasted.error(e.message)
      }
    },
    fromPairs,
  },
}
</script>

<template>
  <AdminLayout>
    <h3 :class="$style.xeAdmin">{{ $t('pg_feeset.fee_bundle_management') }}</h3>
    <table cellspacing="0" cellpadding="0" :class="$style.crossTable">
      <thead>
        <tr>
          <th scope="col"
            ><div>{{ $t('pg_feeset.title') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('pg_feeset.fee_rate') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('pg_feeset.basics') }}</div></th
          >
          <th scope="col">
            <div :class="$style.tRight">
              <a
                href="#"
                :class="[$style.button, $style.black]"
                @click.prevent="handleCreateFeeset"
                ><span>{{ $t('admin.add') }}</span></a
              >
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="feeset in feesets" :key="feeset.seq">
          <td :class="[$style.wide]">{{ feeset.title }}</td>
          <td :class="[$style.tRight, $style.nowrap]">
            {{ feeset.fee_rate | trimDecimalZero }} %
          </td>
          <td :class="[$style.tCenter, $style.nowrap]">
            <input
              type="radio"
              :disabled="loading_feeset_default_change"
              :checked="feeset.is_default === 'Y'"
              name="default_feeset_seq"
              :value="feeset.seq"
              @change="handleChangeDefault($event, feeset.title)"
            />
          </td>
          <td :class="[$style.tRight, $style.nowrap]">
            <a
              href="#"
              :class="[$style.button]"
              @click.prevent="handleUpdateFeeset(feeset)"
              ><span>{{ $t('admin.modify') }}</span></a
            >
            {{ ' ' }}
            <a
              href="#"
              :class="[$style.button, $style.red]"
              @click.prevent="handleDeleteFeeset(feeset.seq)"
              ><span>{{ $t('admin.delete') }}</span></a
            >
          </td>
        </tr>
        <tr v-if="!feesets.length">
          <td :colspan="4" :class="$style.tCenter">{{
            $t('pg_feeset.msg_no_fee')
          }}</td>
        </tr>
      </tbody>
    </table>
    <ElDialog
      :title="
        target_feeset_seq
          ? $t('pg_feeset.modification')
          : $t('pg_feeset.registration')
      "
      :visible.sync="show_feeset_info"
    >
      <FeesetInfo
        v-if="show_feeset_info"
        :key="target_feeset_seq"
        :feeset_seq="target_feeset_seq"
        @submit="handleFeesetSubmit"
      ></FeesetInfo>
    </ElDialog>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';

.colTable th,
.colTable td {
  vertical-align: middle;
}
.adminRightExtra p {
  margin: 10px 0;
}
</style>
